import { Checkbox, DatePicker, Input, Result, Select, Steps, Tooltip, Upload } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";

import "../../Tarefas/style.css";
import { IoMdCheckmark } from "react-icons/io";
import dayjs from "dayjs";
import { InboxOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { formatCNPJ } from "../../../../../function/utilis/function";

const { Dragger } = Upload;

export function CriarNovaTarefa({
  fetchDataObrigacoes,
  setIsCriarNovaTarefa,
  listTipoObrigacao
}) {
  const [currentStep, setCurrentStep] = useState(0);

  const [idClient, setIdClient] = useState(null);
  const [cnpj, setCnpj] = useState("");
  const [ie, setIe] = useState("");
  const [im, setIm] = useState("");
  const [obrigacaoIdToEmit, setObrigacaoIdToEmit] = useState(null);
  const [sigla, setSigla] = useState("");
  const [nomeObrigacao, setNomeObrigacao] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);



  const [mesReferencia, setMesReferencia] = useState(null);
  const [dataVencimento, setDataVencimento] = useState(null);

  const [selectedSituacao, setSelectedSituacao] = useState(null);
  const [situacoesFiltradas, setSituacoesFiltradas] = useState([]);
  const [selectedMotivo, setSelectedMotivo] = useState(null);
  const [motivosFiltrados, setMotivosFiltrados] = useState([]);

  const [checked, setChecked] = useState(false);
  const [files, setFiles] = useState([]);

  

  const items = [
    { title: "Obrigação" },
    { title: "Empresa" },
    { title: "Confirmação" },
  ];

  const situacoes = [
    { id: "A", nome: "Agendada" },
    { id: "B", nome: "Encerrado com fato gerador" },
    { id: "C", nome: "Conhecida" },
    { id: "D", nome: "Dctf Web - Sem movimento" },
    { id: "E", nome: "Emitida" },
    { id: "F", nome: "Sem incidência de fato gerador" },
    { id: "G", nome: "Acumulada" },
    { id: "H", nome: "Encerrado sem fato gerador" },
    { id: "J", nome: "Justificada" },
    { id: "M", nome: "Compensada" },
    { id: "O", nome: "Credor" },
    { id: "P", nome: "Pendente" },
    { id: "R", nome: "Retido" },
    { id: "S", nome: "Sem Movimento" },
    { id: "T", nome: "Apurado na Matriz" },
    { id: "V", nome: "Vencida" },
    { id: "W", nome: "Dctf Web - Transmitida com fato gerador" },
    { id: "Z", nome: "Dctf Web - Zerada" },
  ];

  const motivos = [
  { id: "E-VA", nome: "Valor Acumulado" },
  { id: "J-CINV", nome: "CNPJ Inapto / Baixado" },
  { id: "J-CNE", nome: "Certidão Não Emitida" },
  { id: "J-COM", nome: "Compensado" },
  { id: "J-COMP", nome: "Competência Anterior" },
  { id: "J-DES", nome: "Desobrigada" },
  { id: "J-EF", nome: "Filial / Já Apurado pela Matriz" },
  { id: "J-EF17", nome: "Filial / Já Apurado pela Matriz" },
  { id: "J-EGS", nome: "Esocial - Grupo 1 e 2" },
  { id: "J-EIJ", nome: "Empresa Inativa / Entregue em Janeiro" },
  { id: "J-EL", nome: "Entrega em Lote" },
  { id: "J-EPA", nome: "Empresa em Processo de Abertura" },
  { id: "J-IEINV", nome: "Inscrição Estadual Inválida" },
  { id: "J-IMINV", nome: "Inscrição Municipal Inválida" },
  { id: "J-IRET", nome: "Imposto Retido" },
  { id: "J-ISE-26", nome: "Isenta" },
  { id: "J-ISE-3", nome: "Isenta" },
  { id: "J-PJE", nome: "Pagamento já Efetuado" },
  { id: "J-RR", nome: "Retroativo / Regularização" },
  { id: "J-RTD", nome: "Regime Tributário Divergente" },
  { id: "J-SED", nome: "Segmento de Empresa Divergente" },
  { id: "J-VA", nome: "Valor Agregado" },
];




  const props = {
    beforeUpload: (file) => {
      setFiles([file]); // salva o arquivo no estado
      return false; // impede upload automático
    },
    multiple: false, // só 1 arquivo
    showUploadList: true, // mostra o nome do arquivo
  };

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const prevStep = () => setCurrentStep((prev) => prev - 1);

  const resetForm = () => {
  setIdClient(null);
  setCnpj("");
  setIe("");
  setIm("");
  setObrigacaoIdToEmit(null);
  setSigla("");
  setNomeObrigacao("");
  setDescricao("");
  setValor(0);

  setMesReferencia(null);
  setDataVencimento(null);
  setSelectedSituacao(null);
  setSelectedMotivo(null);
  setChecked(false);
  setFiles([]);
};


  useEffect(() => {
    fetchDataObrigacoes();
  }, []);

  const contadorObrigacaoCalcular = async () => {
    const url = "/portal/rest/contador/obrigacao/calcular";
    const params = {
      cliente: {
        id: idClient,
      },
      obrigacao: {
        id: obrigacaoIdToEmit,
      },
      dataVencimento: "2025-09-15T18:59:31.841Z",
    };

    try {
      const response = await axios.post(url, params, { withCredentials: true });
      if (response.data?.erro) {
        toast.error(response.data.erro.mensagem);
        setIsCriarNovaTarefa(false);
        resetForm();
        setCurrentStep(0);
        return; // encerra a execução
      }

      if (response) {
        console.log("Dados mostrado: ", response);
        setIdClient(response.data.cliente?.id);
        setCnpj(response.data.cliente?.cnpj);
        setIe(response.data.cliente?.ie);
        setIm(response.data.cliente?.im);
        setObrigacaoIdToEmit(response.data.obrigacao?.id);
        setSigla(response.data.obrigacao?.sigla);
        setNomeObrigacao(response.data.obrigacao?.nome);

        setMesReferencia(response.data?.dataReferencia ? dayjs(response.data.dataReferencia) : null);
        setDataVencimento(response.data?.dataVencimento ? dayjs(response.data.dataVencimento) : null);

        setSelectedSituacao(response.data.situacao?.id);

        setSelectedMotivo(
          response.data.motivo?.id === null
            ? "Selecione"
            : response.data.motivo?.id
        );

        if (response.data.situacao?.id) {
          const filtrada = situacoes.filter(
            (s) => s.id === response.data.situacao.id
          );
          setSituacoesFiltradas(filtrada);
        }

        if (response.data.motivo?.id) {
          const filtrados = motivos.filter(
            (m) => m.id === response.data.motivo.id
          );
          setMotivosFiltrados(filtrados);
        }


        
        setDescricao(
          response.data.obrigacao?.nome +
            "- " +
            " ref. " +
            dayjs(response.data?.dataReferencia).format("MM/YYYY")
        );
        setValor(response.data?.valor);
        setChecked(response.data?.liberado === false);
      } else {
        console.error("Erro ao tentar trazer a lista de obrigações.");
      }
    } catch (error) {
      console.error("Erro ao buscar os dados:", error);
    }
  };

  const cadastrarObrigacao = async ({
    idClient,
    obrigacaoIdToEmit,
    mesReferencia,
    dataVencimento,
    selectedSituacao,
    nomeObrigacao,
    descricao,
    valor,
    checked,
    selectedMotivo,
  }) => {
    const url = "/portal/rest/contador/obrigacao/cadastrar";

    const payload = {
      cliente: {
        id: idClient,
      },
      obrigacao: {
        id: obrigacaoIdToEmit,
      },
      dataReferencia: mesReferencia ? dayjs(mesReferencia).toISOString() : null,
      dataVencimento: dataVencimento ? dayjs(dataVencimento).toISOString() : null,
      situacao: {
        id: selectedSituacao, // vem tipo "E"
      },
      nome: nomeObrigacao,
      descricao: descricao,
      valor: valor || "0.00",
      liberado: checked,
      motivo: {
        id: selectedMotivo, // tipo "E-VA"
      },
    };

    try {
      const response = await axios.post(url, payload, {
        withCredentials: true,
      });
      console.log("Cadastrado com sucesso:", response.data);
      return response.data;
    } catch (error) {
      console.error("Erro ao cadastrar a obrigação:", error);
      throw error;
    }
  };

  const handleCadastrar = async () => {
    try {
      await cadastrarObrigacao({
        idClient,
        obrigacaoIdToEmit,
        mesReferencia,
        dataVencimento,
        selectedSituacao,
        nomeObrigacao,
        descricao,
        valor,
        checked,
        selectedMotivo,
      });
      setCurrentStep(2);
      const timer = setTimeout(() => {
      setIsCriarNovaTarefa(false); // fecha o modal
    }, 3000);
      return () => clearTimeout(timer);
    } catch (error) {
      toast.error("Erro ao cadastrar a obrigação.");
    }
  };


  return (
    <>
      {/* Steps no topo */}
      <Steps current={currentStep} labelPlacement="vertical" items={items} />

      {/* Etapa 1 - Dados iniciais */}
      {currentStep === 0 && (
        <>
          <div className="display-just-center-align">
            <div style={{ margin: 5, width: "100px" }}>
              <p>Cliente ID:</p>
              <Input
                placeholder="Cliente ID"
                type="number"
                value={idClient}
                onChange={(event) => setIdClient(event.target.value)}
              />
            </div>

            <div style={{ margin: 5, width: "100%" }}>
              <p>Tipo de Obrigação:</p>
              <Select
                showSearch
                placeholder="Selecione uma opção"
                style={{ width: "100%" }}
                dropdownStyle={{
                  maxHeight: "auto",
                  overflowY: "auto",
                }}
                options={listTipoObrigacao.map((item) => ({
                  value: item.id,
                  label: `${item.sigla} - ${item.nome}`,
                }))}
                onChange={(value) => setObrigacaoIdToEmit(value)}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </div>
          </div>

          <div className="just-display-align">
            <div
              className="btn-next-prev bg-padrao"
              onClick={() => {
                contadorObrigacaoCalcular();
                nextStep();
              }}
            >
              <GrFormNext />
            </div>
          </div>
        </>
      )}

      {/* Etapa 2 - Empresa */}
      {currentStep === 1 && (
        <>
          <div className="display-just-center-align">
            <div style={{ margin: 5 }}>
              <p>Cliente</p>
              <Input
                placeholder={idClient === null ? "Cliente" : idClient}
                type="number"
                disabled="disabled"
                value={idClient}
                onChange={(event) => setIdClient(event.target.value)}
              />
            </div>

            <div style={{ margin: 5 }}>
              <p>CNPJ</p>
              <Input
                placeholder="CNPJ"
                type="text"
                disabled="disabled"
                style={{ width: "300px" }}
                value={formatCNPJ(cnpj)}
                onChange={(event) => setCnpj(event.target.value)}
              />
            </div>

            <div style={{ margin: 5 }}>
              <p>Inscrição Estadual</p>
              <Input
                placeholder="Inscrição Estadual"
                type="text"
                disabled="disabled"
                style={{ width: "300px" }}
                value={ie}
                onChange={(event) => setIe(event.target.value)}
              />
            </div>
          </div>

          <div className="display-just-center-align">
            <div style={{ margin: 5, width: "160px" }}>
              <p>Inscrição Municipal</p>
              <Input
                placeholder="Inscrição Municipal"
                type="number"
                disabled="disabled"
                width="160px"
                value={im}
                onChange={(event) => setIm(event.target.value)}
              />
            </div>

            <div style={{ margin: 5, width: "150px" }}>
              <p>CNAE Anexos</p>
              <Input
                placeholder="CNAE Anexos"
                type="text"
                disabled="disabled"
                style={{ width: "150px" }}
              />
            </div>

            <div style={{ margin: 5, width: "110px" }}>
              <p>Obrigação</p>
              <Input
                placeholder="Obrigação"
                type="text"
                disabled="disabled"
                style={{ width: "110px" }}
                value={obrigacaoIdToEmit}
                onChange={(event) => setObrigacaoIdToEmit(event.target.value)}
              />
            </div>

            <div style={{ margin: 5, width: "330px" }}>
              <p>Nome</p>
              <Input
                placeholder="Nome"
                type="text"
                disabled="disabled"
                style={{ width: "330px" }}
                value={nomeObrigacao}
                onChange={(event) => setNomeObrigacao(event.target.value)}
              />
            </div>
          </div>

          <div className="display-just-center-align">
            <div style={{ margin: 5, width: "180px" }}>
              <p>Mês de Referência</p>
              <DatePicker
                picker="month"
                format="MM/YYYY"
                placeholder="MM/YYYY"
                style={{ width: "100%" }}
                value={mesReferencia}
                onChange={(date) => setMesReferencia(date)}
              />
            </div>

            <div style={{ margin: 5, width: "180px" }}>
              <p>Data Vencimento</p>
              <DatePicker
                picker="month"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                style={{ width: "100%" }}
                value={dataVencimento}
                onChange={(date) => setDataVencimento(date)}
              />
            </div>

            <div style={{ margin: 5, width: "200px" }}>
              <p>Situação</p>
              <Select
                placeholder="Selecione"
                style={{ width: 200 }}
                value={selectedSituacao}
                onChange={(value) => setSelectedSituacao(value)}
                options={situacoesFiltradas.map((item) => ({
                  value: item.id,
                  label: item.nome,
                }))}
              />

            </div>

            <div style={{ margin: 5, width: "200px" }}>
              <p>Motivo</p>
              <Select
                placeholder="Selecione"
                style={{ width: 200 }}
                value={selectedMotivo} // ex: "E-VA"
                onChange={(value) => setSelectedMotivo(value)}
                options={motivosFiltrados.map((item) => ({
                  value: item.id,
                  label: item.nome,
                }))}
              />

            </div>
          </div>

          <div className="display-just-center-align">
            <div style={{ margin: 5, width: "400px" }}>
              <p>Descrição</p>
              <Input 
                placeholder="Descrição" 
                type="text" 
                value={descricao} 
                onChange={(event) => setDescricao(event.target.value)}
              />
            </div>

            <div style={{ margin: 5, width: "200px" }}>
              <p>Valor</p>
              <Input 
                placeholder="Valor" 
                type="text" 
                value={valor}
                onChange={(event) => setValor(event.target.value)}
              />
            </div>

            <div style={{ margin: 5, width: "150px" }}>
              <p>Disponibilização Portal</p>
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                disabled={true}
              >
                Liberado
              </Checkbox>
            </div>
          </div>

          <br />

          <div className="display-just-center-align">
            <Dragger {...props} style={{ padding: 5 }}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Clique ou arraste o arquivo para esta área
              </p>
              <p className="ant-upload-hint">Apenas um arquivo será aceito</p>
            </Dragger>
          </div>

          <div className="just-display-align">
            <div className="just-display-align">
              <div className="btn-next-prev bg-padrao" onClick={prevStep}>
                <GrFormPrevious />
              </div>
            </div>
            <Tooltip title="Criar tarefa">
              <div
                className="btn-next-prev bg-confirm"
                onClick={handleCadastrar}
              >
                <IoMdCheckmark />
              </div>
            </Tooltip>
          </div>
        </>
      )}

      {/* Etapa 3 - Confirmação */}
      {currentStep === 2 && (
        <Result
          status="success"
          title="Tarefa criada com sucesso!"
        />
      )}
    </>
  );
}

export default CriarNovaTarefa;
